import { Chock } from "@/pages/catalogs/models/Chock";
import { MenuOptionType } from "@dexteel/mesf-core";
import { DeleteSweep } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from "@mui/icons-material/FileCopy";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";

type Props = {
	setSelectedRowData: (chock: Chock) => void;
	setShowModal: (
		modal: "create" | "update" | "delete" | "deleteMultiple" | "",
	) => void;
};
export const useChockOptionsFunctions = ({
	setSelectedRowData,
	setShowModal,
}: Props) => {
	const getMenuOptions = (data: Chock | any) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Chock",
				key: "new_chock",
				onClick: () => {
					setShowModal("create");
				},
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			options = options.concat([
				{
					name: "Edit Chock",
					key: "edit_chock",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("update");
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Chock",
					key: "delete_chock",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("delete");
					},
					icon: <DeleteIcon />,
				},
				...(data.selectedRows.length > 1
					? [
							{
								name: `Delete selected (${data.selectedRows.length})`,
								key: "delete_selected_chocks",
								onClick: () => {
									setShowModal("deleteMultiple");
								},
								icon: <DeleteSweep />,
							},
						]
					: []),
				{
					name: "Duplicate Chock",
					key: "duplicate_chock",
					onClick: () => {
						setSelectedRowData({
							...data,
							PartName: `${data.PartName} (Copy)`,
							RFIDTag: null,
							IsDuplicate: true,
						});
						setShowModal("create");
					},
					icon: <ContentCopyIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
